<ng-container *ngIf="!initialLoading; else initialLoadingTemp">
  <ng-container *ngIf="{ value: options$$ | async } as options">
    <glxy-alert
      type="warning"
      *ngIf="noResultsWarning && showNoResultsWarning"
      class="automation-replacement-chips__no-results-warning"
    >
      {{ noResultsWarning | translate }}
    </glxy-alert>
    <glxy-form-field
      [required]="isRequired"
      [disabled]="disabled$ | async"
      [bottomSpacing]="bottomSpacing"
      [showLabel]="showLabel"
    >
      <glxy-label *ngIf="label">{{ label | translate | automataCapitalize }}</glxy-label>
      <mat-chip-grid #chipGrid [disabled]="chipsDisabled">
        <ng-container *ngIf="multiple">
          <mat-chip-row
            *ngFor="let selectedOption of selectedOptions.value; let i = index"
            [removable]="true"
            (removed)="removeEntity(i)"
          >
            {{ displayFn(selectedOption) | async | translate }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </ng-container>
        <ng-container *ngIf="!multiple && selectedOptions.value !== null && selectedOptions.value !== undefined">
          <mat-chip-row [removable]="true" (removed)="removeEntity(0)">
            {{ displayFn(selectedOptions.value) | async | translate }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </ng-container>

        <input
          #searchEntities
          [placeholder]="placeholder"
          [matChipInputFor]="chipGrid"
          [matChipInputAddOnBlur]="false"
          [matAutocomplete]="auto"
          [formControl]="searchControl"
          [disabled]="disabled$ | async"
          [readOnly]="!supportsSearching && !allowCustomValues"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          #trigger="matAutocompleteTrigger"
          (click)="inputClick(trigger)"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectEntity($event)" [requireSelection]="false">
          <mat-option *ngFor="let option of options.value" [value]="option">
            {{ displayFn(option) | async | translate }}
          </mat-option>
          <mat-option *ngIf="loadingMore" [disabled]="true" class="automation-replacement-chips__spinner-option">
            <div>
              <glxy-loading-spinner size="small"></glxy-loading-spinner>
            </div>
          </mat-option>
          <mat-option
            *ngIf="!loadingMore && showSearchNotFound"
            [disabled]="true"
            class="automation-replacement-chips__no-results-option"
          >
            {{ noResultsFound | translate }}
          </mat-option>
          <glxy-infinite-scroll-trigger
            [visiblilityMargin]="120"
            (isVisible)="loadMore()"
          ></glxy-infinite-scroll-trigger>
        </mat-autocomplete>
      </mat-chip-grid>
      <automata-automation-variable-menu
        *ngIf="supportDataPassing && (disabled$ | async) === false"
        [supportedDataTypes]="supportedDataTypes"
        [includeRepeatedParams]="multiple"
        matSuffix
        useGalaxyCompat="true"
        dontIncludeDefaultCategories="true"
        (variableSelected)="replacementVariableSelected($event)"
      ></automata-automation-variable-menu>
      <glxy-error *ngIf="selectedOptions.hasError('required') && selectedOptions.dirty">
        {{ 'COMMON.REQUIRED' | translate }}
      </glxy-error>
      <glxy-hint *ngIf="hint$ | async as fieldHint">
        {{ fieldHint | translate }}
      </glxy-hint>
    </glxy-form-field>
  </ng-container>
</ng-container>

<ng-template #initialLoadingTemp>
  <div class="side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
